import React, { useEffect, useState } from 'react';
import "../Css/CheckOutPage.css";
import Footer from '../Component/FooterComponent/Footer';
import OrderDeatils from '../Component/checkout/OrderDeatils';
import OrderAddress from '../Component/checkout/OrderAddress';
import Orderlogin from '../Component/checkout/Orderlogin';
import { useSelector } from "react-redux";
import PayOrder from '../Component/checkout/PayOrder';
import axios from 'axios';
import { API_BASE_URL } from '../services/apiConfig';

const CheckOutPage = () => {
    const tokenid = localStorage.getItem("access_token");
    const profileData = JSON.parse(localStorage.getItem('profile'));
    
    // Safely get user_id with fallback
    const userId = profileData?.user_id || profileData?.id || 5;

    const [selectedAddress, setSelectedAddress] = useState(null);
    const [allAddressData, setAlladdressData] = useState([]);

    const AllAddress = async (selectFirstAddress = true) => {
        try {
            const response = await axios.get(`${API_BASE_URL}addresses?userId=${userId}`);
            
            if (response.data && response.data.success) {
                const addressListData = response.data.data || [];
                console.log("addressListData", addressListData);
                
                setAlladdressData(addressListData);

                if (selectFirstAddress) {
                    const activeAddress = addressListData.find(address => address.is_default === 1) || addressListData[0] || null;
                    setSelectedAddress(activeAddress);
                }
                return addressListData;
            } else {
                setAlladdressData([]);
                if (selectFirstAddress) setSelectedAddress(null);
                return [];
            }
        } catch (error) {
            console.error('Error fetching addresses:', error);
            setAlladdressData([]);
            if (selectFirstAddress) setSelectedAddress(null);
            return [];
        }
    };

    useEffect(() => {
        if (userId) {
            AllAddress();
        }
    }, [tokenid, userId]);

    const { token } = useSelector((state) => state.auth);

    return (
        <>
            <section className='men-product-banner-section'>
                <div className='men-product-banner-con'>
                </div>
            </section>

            <section className='CheckOutPage-Section-2'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-7'>
                            {token ? (
                                <>
                                    <OrderDeatils />
                                    <OrderAddress
                                        selectedAddress={selectedAddress}
                                        setSelectedAddress={setSelectedAddress}
                                        allAddressData={allAddressData}
                                        setAlladdressData={setAlladdressData}
                                        refreshAddresses={AllAddress}
                                    />
                                </>
                            ) : (
                                <Orderlogin />
                            )}
                        </div>
                        <div className='col-md-5'>
                            <PayOrder
                                selectedAddress={selectedAddress}
                                setSelectedAddress={setSelectedAddress}
                                allAddressData={allAddressData}
                                setAlladdressData={setAlladdressData}
                            />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default CheckOutPage;